/**
 * Kreis-Initialen (Vertrag §2.6): höchstens zwei Buchstaben.
 */

export function initialen(name: string | null | undefined): string {
  if (!name?.trim()) return "?";
  const teile = name
    .trim()
    .split(/\s+/)
    .map((t) => t.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean);
  if (teile.length === 0) return "?";
  if (teile.length === 1) {
    const wort = teile[0]!;
    return wort.slice(0, 2).toLocaleUpperCase("de-DE");
  }
  const a = teile[0]![0] ?? "";
  const b = teile[teile.length - 1]![0] ?? "";
  return `${a}${b}`.toLocaleUpperCase("de-DE");
}
